<template>
  <el-container
    class="taskpage-container"
    v-loading="TaskListLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-header>
      <!-- <Header></Header> -->
    </el-header>
    <el-main class="container-main">
      <div class="taskpage-processing">
        <div class="taskpage-processing-back">
          <i class="el-icon-arrow-left"  @click="goBack()"></i>
          <span class="task-title">{{taskTitle}}</span>
        </div>

        <div class="task-des-container">
          <div class="taskpage-processing-button">
<!--            <el-button v-if="historyTodoData>5" @click="notGoPatient()" type="" style="color:gray; border-color:#999;">开始随访（{{tasks.followupNumber}}）</el-button>-->
            <el-button @click="goPatient(2,tasks.followupNumber)" :disabled="tasks.followupNumber ==0 || !isAllowFollow" type="">开始随访（{{tasks.followupNumber}}）</el-button>
<!--            <el-button @click="goPatient(1,tasks.smsFollowupNumber)":disabled="tasks.smsFollowupNumber ==0" type="">短信随访未完成（{{tasks.smsFollowupNumber}}）</el-button>-->
            <el-button v-if="$route.query.isOpen == 1" @click="goPatient(3,tasks.questionnaireNumber)" :disabled="tasks.questionnaireNumber ==0" type="">问卷录入（{{tasks.questionnaireNumber}}）</el-button>
<!--            <span-->
<!--              :class="tasks.followupNumber !==0?'hasData':''"-->
<!--              @click="goPatient(2,tasks.followupNumber)"-->
<!--            >开始随访（{{tasks.followupNumber}}）</span>-->
<!--            <span-->
<!--              :class="tasks.smsFollowupNumber !==0?'hasData':''"-->
<!--              @click="goPatient(1,tasks.smsFollowupNumber)"-->
<!--            >短信随访未完成（{{tasks.smsFollowupNumber}}）</span>-->
<!--            <span-->
<!--                v-if="$route.query.isOpen == 1"-->
<!--                :class="tasks.questionnaireNumber !==0?'hasData':''"-->
<!--                @click="goPatient(3,tasks.questionnaireNumber)"-->
<!--            >问卷录入（{{321321321}}）</span>-->
          </div>
          <div class="task-des-item">
            <div class="task-des task-des-hidden">
              呼叫总时长：
              <span v-text="`${statistics.callTimeResult}`"></span>
            </div>
            <div class="task-des task-des-hidden">
              拨叫人数：
              <span v-text="`${statistics.todayPerson}`"></span>
            </div>
            <div class="task-des task-des-hidden">
              随访成功人数：
              <span v-text="`${statistics.todayCompleteNumber}`"></span>
            </div>
            <div class="task-des task-des-hidden">
              电话拨打次数：
              <span v-text="`${statistics.todayPhone}`"></span>
            </div>
            <div class="task-des task-des-followup task-des-hidden" @click="goFollowupFinished">
              完成随访人数：
              <span v-text="`${statistics.completeFollowupNumber}`"></span>
            </div>
            <el-tooltip
              class="task-des task-des-followup task-des-tooltip"
              effect="light"
              :content="tooltipContent"
              placement="bottom-end"
              :enterable="false"
            >
              <span @click="goFollowupFinished">
                完成随访人数：
                <span v-text="`${statistics.completeFollowupNumber}`"></span>
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="taskpage-content">
        <div class="taskpage-content-item">
          <div class="taskpage-content-title">
            <span class="title">质控看板</span>
          </div>
          <div class="tabs-container">
            <el-tabs v-model="activeName" @tab-click="handleBoardClick" class="new-tabs-header">
              <el-tab-pane :label="boardLabel.all" name="all"></el-tab-pane>
              <el-tab-pane :label="boardLabel.replay" name="replay"></el-tab-pane>
              <!-- <el-tab-pane label="合格" name="qualified"></el-tab-pane> -->
              <el-tab-pane :label="boardLabel.modification" name="modification"></el-tab-pane>
              <el-tab-pane :label="boardLabel.remind" name="remind"></el-tab-pane>
              <el-tab-pane :label="boardLabel.complexReplyNum" name="complexReplyNum"></el-tab-pane>
            </el-tabs>
            <span class="refresh-all" @click="clickRefreshLeft">数据不对？点击这里刷新</span>
          </div>
          <ControllerTable v-if="showControllerTable" @aliyunLogin="aliyunLogin" class="controller-table" :spotCheckState="spotCheckState"></ControllerTable>
        </div>
        <div class="taskpage-content-item">
          <div class="taskpage-content-title">
            <span class="title">未完成随访</span>
            <span @click="clickRefreshRight" class="refresh-all-right">数据不对？点击这里刷新</span>
          </div>
          <div class="tabs-collect">
            <el-tabs
              v-model="unfinishedFollowup"
              @tab-click="handleUnfinishedClick"
              class="new-tabs-header"
            >
              <el-tab-pane :label="unfinishedLabel.all" name="all"></el-tab-pane>
              <el-tab-pane :label="unfinishedLabel.abnormalNum" name="abnormalNum"></el-tab-pane>
              <el-tab-pane :label="unfinishedLabel.callLaterNum" name="callLaterNum"></el-tab-pane>
              <!-- 需复核：管理台开启 -->
              <el-tab-pane :label="unfinishedLabel.reviewPoolNum" v-if="isReviewPool" name="reviewPoolNum"></el-tab-pane>

              <el-tab-pane v-for="(item, index) in filetableData" 
              :key="index" 
              :label="item.fileNameResult"
              :name="item.id?item.id.toString():''"
              ></el-tab-pane>

            </el-tabs>
            <span class="collect-setting" >
              <i @click="collectDialogOpen" class="el-icon-more"></i>
            </span>
          </div>
          <PatientTable v-if="showPatientTable" @aliyunLogin="aliyunLogin"
          class="patient-table" 
          :unfinishedCheckState="unfinishedCheckState"
          :fileId="fileId"
          ></PatientTable>
        </div>
      </div>
      <!-- 收藏夹 -->
      <el-dialog
        title="收藏夹菜单"
        :visible.sync="collectDialogVisible"
        class="collect-dialog"
        width="30%">
        <div class="content">
          <div class="table-container">
            <el-table :data="filetableData" v-loading="fileTableLoading" border style="width: 100%">
              <el-table-column prop="fileName"  align="center" label="收藏夹名称">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isEdit" v-model="scope.row.fileName" placeholder="请输入收藏夹名称" maxlength="6" show-word-limit size="small"></el-input>
                  <span v-else>{{scope.row.fileName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                  <div v-if="!scope.row.isEdit">
                    <el-button @click="editExceptionFileRow(scope.$index)" size="small" type="primary">
                      重命名
                    </el-button>
                    <el-button @click="deleteExceptionFile(scope.row)" type="danger" size="small">删 除</el-button>
                  </div>
                  <div v-else>
                    <el-button @click="editExceptionFile(scope.row)" type="primary" size="small">
                      保 存
                    </el-button>
                    <el-button @click="cancelEdit(scope.$index)" size="small">
                      取 消
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="collect-dialog-bottom">
            <el-button size="medium" type="primary" @click="addExceptionFile(1,{})">新建收藏夹</el-button>
            <span>
              <el-button size="medium" @click="collectDialogClose">关闭</el-button>
            </span>
          </div>
        </div>
      </el-dialog>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script type="text/ecmascript-6">
import Header from "../common/Header";
import Footer from "../common/Footer";
import {mapGetters, mapMutations, mapState} from "vuex";
import {
  RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo,
  RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckStatistics, //获取随访任务统计信息
  RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount
} from "@src/assets/js/api.js";
import BigNumber from "bignumber.js";
import qsDetailDB from "@src/assets/qsList/indexDB.js";
// import aliyunCallMixin from "@mixins/aliyunCallMixin";
import {MyMixin} from "@mixins/aliyunCallMixin"
import * as aliyunConfig from "@config/aliyun.config.js";
import axios from "axios";
import storage from "../../assets/js/storage";

import errorHandleMixin from "@mixins/errorHandleMixin";
import ControllerTable from "./components/ControllerTable";
import PatientTable from "./components/PatientTable";
import qs from "qs";
import { lchown } from 'fs';
import {RestNewFollowupCallCenterServiceGetSeatsIsAllowFollowup} from "../../assets/js/api";
export default {
  name: "TaskNewPage",
  data() {
    return {
      versionSip: "0.5.0",
      versionAgentbar: "1.11.0",
      versionworkBench: "2.7.0",
      showControllerTable: true,
      showPatientTable: true,
      loading: null,
      timer: null,
      activeName: "replay",
      unfinishedFollowup: "all",
      selectAudio: 0,
      currentAudioList: [],
      spotCheckState: 1,  //质控看板
      unfinishedCheckState: 4, // 未完成随访
      showAudio: false,
      tabPosition: 3,
      tasks: {},
      isAllowFollow: {},
      TaskListLoading: false,
      tableData: [],
      boardLabel: {
        all:"全部（0）",
        replay: "需重拨（0）",
        remind: "需注意（0）",
        modification: "需修改（0）",
      },
      unfinishedLabel: {
        all: "全部",
        abnormalNum: "异常随访（0）",
        callLaterNum: "稍后拨打（0）",
        reviewPoolNum: "需复核（0）",
      },
      isReviewPool: false, //需复核
      tooltipContent: "",
      todayCompletedCount: 0,
      historyTodoData:0,
      // 收藏夹
      collectDialogVisible: false,
      filetableData:[],
      fileTableLoading:false,
      fileId: null,
    };
  },
  mixins: [errorHandleMixin,MyMixin],
  computed: {
    ...mapGetters([
      "username",
      "userid",
      "getTaskCenterId",
      "questionId",
      "taskTitle"
    ]),
    ...mapState(["taskType"]),
    statistics() {
      let statictics = {
        sumTask: 30,
        overdueTask: 10,
        todayTask: 10,
        tomorrowTask: 30,
        todayPhone: this.tasks.todayTelephoneDialNumber || 0,
        todayPerson: this.tasks.todayCallNumber || 0,
        completeFollowupNumber: this.tasks.completeFollowupNumber || 0,
        callLaterNumber: this.tasks.callLaterNumber || 0,
        // todayCompleteNumber: this.tasks.success || 0, getTodayCompletedCount()
        todayCompleteNumber: this.todayCompletedCount,
        callTimeResult: this.tasks.callTimeResult || "0",
      };
      if (!statictics.todayPerson) {
        statictics.probability = "0%";
      } else {
        statictics.probability =
          new BigNumber(statictics.completeFollowupNumber)
            .div(statictics.todayPerson)
            .times(100)
            .toNumber()
            .toFixed(1) + "%";
      }
      this.tooltipContent="拨叫人数："+ (this.tasks.todayTelephoneDialNumber || 0 )+"\xa0\xa0随访成功人数："+ this.todayCompletedCount+"\xa0\xa0电话拨叫人数："+ (this.tasks.todayTelephoneDialNumber || 0)+"\xa0\xa0完成随访人数："+(this.tasks.completeFollowupNumber||0);
      return statictics;
    }
  },
  
  components: {
    Header,
    Footer,
    ControllerTable,
    PatientTable
    // vueAudioPlayer
  },
  mounted() {
    // qsDetailDB.openDatabase();
    window.pubsub &&
      window.pubsub.off("refreshHomePage").on("refreshHomePage", () => {
        this.getTaskList();
        this.getTodayCompletedCount();
        this.getFollowUpTaskSpotCheckStatistics();
        this.getExceptionFile()
        this.getSeatsIsAllowFollowup()
      });
  },
   created() {
    if (this.$route.query.type) {
      this.spotCheckState = this.$route.query.type*1
      this.activeName = this.getActiveName(this.spotCheckState)
    }else {
      this.spotCheckState = 1; //0：全部
    }
    this.getSeatAndTodoInfo()
    this.getTaskList();
    this.getTodayCompletedCount();
    this.getFollowUpTaskSpotCheckStatistics();
    this.getExceptionFile()
    this.getSeatsIsAllowFollowup()
    if (this.$route.query.tabIndex) {
      this.unfinishedFollowup = this.$route.query.tabIndex
      this.fileId = this.$route.query.tabIndex
      this.unfinishedCheckState = 3;
    }else {
      this.unfinishedCheckState = 4;
    }
  },
  methods: {
    ...mapMutations({
      callEvent: "callEvent",
      logout: "logout",
      setContactId: "setContactId",
    }),
    clickRefreshLeft() {
      this.getFollowUpTaskSpotCheckStatistics()
      this.showControllerTable = false
      setTimeout(() => {
        this.showControllerTable = true
      },300)
    },
    clickRefreshRight() {
      this.getTaskList()
      this.showPatientTable = false
      setTimeout(() => {
        this.showPatientTable = true
      },300)
    },//
    getSeatsIsAllowFollowup() {
      this.$store.dispatch('requestHandler',{
        fn: "RestNewFollowupCallCenterServiceGetSeatsIsAllowFollowup",
        params: {
          userId: this.userid,
          taskId: this.getTaskCenterId,
        }
      }).then(res => {
          this.isAllowFollow = res.retValue
          console.log('isAllowFollow', this.isAllowFollow);
        })
    },
    // 获取
    getTaskSwitchMark() {
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestNewFollowupCallCenterServiceGetFollowUpTaskSwitchMark',
          params: { followUpTaskId: this.getTaskCenterId}
        }
      ).then(res => {
        if (res.status==0) {
          this.isReviewPool = res.retValue.isReviewPool
        }
      })
    },
    //阿里云灯登录
    // 获取 任务列表
    getTaskList() {
      let vm = this;
      console.log('getTaskCenterId',this.getTaskCenterId);
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        isFrontPage:this.$route.query.isFrontPage?true:false
      };
      if (typeof params.userId === "undefined") {
        this.errorHandle({ message: "无法获取操作人员的ID,请重新登录" });
        return false;
      }
      this.TaskListLoading = true;
      return this.asyncGetStatis(params)
        .then(data => {
          if (data.status === 0) {
            this.tasks = data.retValue;
            this.tasks.callTimeResult = this.convertMsToTime(data.retValue.callTime || 0)

            this.unfinishedLabel = {
              all: '全部',
              abnormalNum:
                "异常随访（" + data.retValue.followupAbnormalNumber + "）",
              callLaterNum: "稍后拨打（" + data.retValue.callLaterNumber + "）",
              reviewPoolNum: "需复核（" + data.retValue.reviewPoolNumber + "）",
            };
            this.getTaskSwitchMark()
          } else {
            vm.errorHandle(data);
          }
          this.TaskListLoading = false;
        })
        .catch(err => {
          console.log("task list  handle --- ", err);
          vm.errorHandle(err);
          this.TaskListLoading = false;
        });
    },
    convertMsToTime(ms) {
      var seconds = Math.floor(ms / 1000);
      var minutes = Math.floor(seconds / 60);
      var hours = Math.floor(minutes / 60);

      seconds = seconds % 60;
      minutes = minutes % 60;

      var timeString = "";

      if (hours > 0) {
        timeString += hours + "小时";
      }

      if (minutes > 0) {
        timeString += minutes + "分钟";
      }

      if (seconds > 0) {
        timeString += seconds + "秒";
      }
      return timeString;
    },
    getSeatAndTodoInfo(){
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestCallCenterOperationPlatformControllerGetSeatFinishAndTodoInfo',
          params: { seatId: this.userid}
        }
      ).then(res => {
        if (res.status==0) {
          this.historyTodoData = res.retValue.todoRedialTotalCount + res.retValue.todoChangeTotalCount
        }else {
          this.historyTodoData = 0
        }
      })
    },
    notGoPatient(){
      this.$alert(`<div style="color:#F21702;font-size:16px;">您已累计${this.historyTodoData}项待处理的任务</div><div>请先处理你的待办事项，否则无法开始随访哦~</div>`, '', {
        dangerouslyUseHTMLString: true
      });
    },
    // 获取今日完成人数
    getTodayCompletedCount() {
      let vm = this;
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId
      };
      if (typeof params.userId === "undefined") {
        this.errorHandle({ message: "无法获取操作人员的ID,请重新登录" });
        return false;
      }
      this.getFollowUpTodayCompleteCountAsync(params)
        .then(data => {
          if (data.status === 0) {
            this.todayCompletedCount = data.retValue.success;
          }
        })
        .catch(err => {
          vm.errorHandle(err);
        });
    },

    goFollowupFinished() {
      this.$router.push({
        path: "/followupFinished",
        query: {
          taskType: this.taskType,
          abnormal: 5,
          diseaseId: this.$route.query.diseaseId
        }
      });
    },
    goPatient(num, dataNum) {
      if(window.workbench) {
        if(num == 3 && dataNum != 0) {
          this.$router.push({
            path: "/completeQuestion",
            query: {
              isFrontPage: this.$route.query.isFrontPage ? true:false,
              taskType: this.taskType,
              abnormal: num, //随访的是'2'，短信随访未完成是 '1'
              diseaseId: this.$route.query.diseaseId,
              followupSource: 1,
              isRemindStudy: this.$route.query.isRemindStudy,
              isSingleDuration: this.$route.query.isSingleDuration,
              isTotalDuration: this.$route.query.isTotalDuration,
            }
          });
          return
        }
        else if (dataNum > 0) {
          this.$router.push({
            path: "/callPatient",
            query: {
              isOpen: this.$route.query.isOpen,
              isFrontPage: this.$route.query.isFrontPage ? true:false,
              taskType: this.taskType,
              abnormal: num, //随访的是'2'，短信随访未完成是 '1'
              diseaseId: this.$route.query.diseaseId,
              followupSource: 1,
              isRemindStudy: this.$route.query.isRemindStudy,
              isSingleDuration: this.$route.query.isSingleDuration,
              isTotalDuration: this.$route.query.isTotalDuration,
            }
          });
        }
      }else {

        this.initAliyunCall()
            .then((result) => {
              console.log('result',result);
              if(result) {
                if(num == 3 && dataNum != 0) {
                  this.$router.push({
                    path: "/completeQuestion",
                    query: {
                      isFrontPage: this.$route.query.isFrontPage ? true:false,
                      taskType: this.taskType,
                      abnormal: num, //随访的是'2'，短信随访未完成是 '1'
                      diseaseId: this.$route.query.diseaseId,
                      followupSource: 1,
                      isRemindStudy: this.$route.query.isRemindStudy,
                      isSingleDuration: this.$route.query.isSingleDuration,
                      isTotalDuration: this.$route.query.isTotalDuration,
                    }
                  });
                  return
                }
                else if (dataNum > 0) {
                  this.$router.push({
                    path: "/callPatient",
                    query: {
                      isOpen: this.$route.query.isOpen,
                      isFrontPage: this.$route.query.isFrontPage ? true:false,
                      taskType: this.taskType,
                      abnormal: num, //随访的是'2'，短信随访未完成是 '1'
                      diseaseId: this.$route.query.diseaseId,
                      followupSource: 1,
                      isRemindStudy: this.$route.query.isRemindStudy,
                      isSingleDuration: this.$route.query.isSingleDuration,
                      isTotalDuration: this.$route.query.isTotalDuration,
                    }
                  });
                }
                this.clearInter();

              }
            })
            .catch((err) => {
              console.log('err',err);
              // this.errorHandle(err);

            });
      }



    },

    // ========================质控看板的内容========================
    getFollowUpTaskSpotCheckStatistics() {
      let params = {
        followupTaskId: this.getTaskCenterId,
        userId: this.userid
      };
      this.getFollowUpTaskSpotCheckStatisticsAsync(params).then(res => {
        this.boardLabel = {
          all: "全部（"+ res.retValue.totalCount+"）",
          replay: "需重拨（" + res.retValue.requireReplayNum + "）",
          remind: "需注意（" + res.retValue.requireRemindNum + "）",
          modification:
            "需修改（" + res.retValue.requireChangeNum + "）",
          complexReplyNum: `复杂重拨（${res.retValue.complexReplyNum}）`
        };
      });
    },
    handleBoardClick(tab, event) {
      switch (tab.name) {
        case "all":
          this.spotCheckState = 0;
          break;
        case "replay":
          this.spotCheckState = 1;
          break;
        case "remind":
          this.spotCheckState = 2;
          break;
        case "modification":
          this.spotCheckState = 4;
          break;
        case "complexReplyNum":
          this.spotCheckState = 5;
          break;
      }
    },
    getActiveName(type){
      let name='replay'
      switch (type) {
        case 0:
          name='all'
          break;
        case 1:
          name='replay'
          break;
        case 2:
          name='remind'
          break;
        case 4:
          name='modification'
          break;
      }
      return name
    },
    // ============================未完成随访=================
    handleUnfinishedClick(tab, event) {
      this.showPatientTable = false

      if (tab.name=="abnormalNum") {
        this.unfinishedCheckState = 1;
      }else if (tab.name=="callLaterNum"){
        this.unfinishedCheckState = 2;
      }else if (tab.name=="all") {
        this.unfinishedCheckState = 4;
      }else if(tab.name=="reviewPoolNum"){
        this.unfinishedCheckState = 5;

      } else {
        this.unfinishedCheckState = 3;
        this.fileId = tab.name
      }
      setTimeout(() => {
        this.showPatientTable = true
      },300)
    },
    goBack() {
      this.$router.push({
        path: "/taskList"
      });
      // this.$router.go(-1)
    },
    collectDialogOpen(){
      this.collectDialogVisible=true;
      this.getExceptionFile()
    },
    collectDialogClose(){
      // let index = this.filetableData.findIndex(function(item) {
      //   return item.isEdit === true;
      // });
      // if (index > -1) {
      //   this.cancelEdit(index)
      // }
      let _filetableData = this.filetableData.filter(item => item.isEdit)
      if (_filetableData.length>0) {
        this.$message.warning("请先保存编辑中的收藏夹")
        return 
      }
      this.collectDialogVisible=false;
    },
    editExceptionFileRow(index) {
      let _filetableData = this.filetableData.filter(item => item.isEdit)
      if (_filetableData.length>0) {
        this.$message.warning("请先保存编辑中的收藏夹")
        return 
      }
      this.filetableData[index].isEdit = true;
    },
    saveExceptionFileRow(index) {
      this.filetableData[index].isEdit = false;
    },
    cancelEdit(index) {
      this.filetableData[index].isEdit = false;
      // 可以将文件名称重置为原始值
      if (this.filetableData[index].id) {
        this.filetableData[index].fileName = this.filetableData[index].initFileName;
      }else {
        this.filetableData.splice(index, 1);
      }
    },
    addExceptionFile(type,row){
      let _length = this.filetableData.filter(item => item.isEdit).length
      if (_length > 0) {
        this.$message.warning("请先保存编辑中的收藏夹")
        return
      }
      this.fileName = type==2 ?row.fileName:""
      this.fileId = type==2? row.id : null
      if (type == 1 && this.filetableData.length==6) {
        this.$message.warning("最多创建6个收藏夹")
        return
      }
      this.filetableData.push({
        id: null,
        fileName: "",
        isEdit: true,
        initFileName: ""
      })
      
    },
    editExceptionFile(row){
      let _fileName = row.fileName
      let fileNameArr=[]
      this.filetableData.forEach(item => {
        if (item.id && row.id!=item.id) {
          fileNameArr.push(item.initFileName)
        }
      })
      if (!this.validateString(_fileName)) {
        this.$message.warning("收藏夹名称不能为空！")
        return
      }
      if (fileNameArr.indexOf(_fileName) != -1) {
        this.$message.warning("收藏夹名称已存在！")
        return
      }
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestAbnormalFollowupFileControllerEditExceptionFile',
          params: {
            id: row.id|| null,
            seatId:this.userid,
            taskId:this.getTaskCenterId,
            fileName: _fileName,
          }
        }
      ).then(res => {
        if (res.status==0) {
          this.$message.success("保存成功")
          this.getExceptionFile()
        }
      })
    },
    deleteExceptionFile(row){
      this.$confirm('是否确认删除该收藏夹？删除后将无法恢复', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('requestHandler',
          {
            fn: 'RestAbnormalFollowupFileControllerDeleteExceptionFile',
            params: {id: row.id}
          }
        ).then(res => {
          if (res.status==0) {
            this.$message.success("删除成功")
            this.getExceptionFile()
          }else {
            this.$message.warning(res.desc)
          }
        })
      }).catch(() => {});
    },
    getExceptionFile(){
      this.fileTableLoading = true
      this.filetableData = []
      this.$store.dispatch('requestHandler',
        {
          fn: 'RestAbnormalFollowupFileControllerGetExceptionFile',
          params: {
            seatId:this.userid,
            taskId:this.getTaskCenterId,
          }
        }
      ).then(res => {
        this.fileTableLoading = false
        if (res.status==0 && res.retValue.length>0) {
          this.filetableData= res.retValue.map(item => {
            item.fileNameResult = `${item.fileName}(${item.patientNum})`
            item.initFileName = item.fileName
            item.isEdit = false
            return item
          })
          if (this.$route.query.tabIndex) {
            this.unfinishedFollowup = this.$route.query.tabIndex
            this.fileId = this.$route.query.tabIndex
            this.unfinishedCheckState = 3;
          }
        }else {
          this.filetableData = []
        }
      })
    },
    validateString(str) {
      var reg = /^\s+$/;
      return str.trim().length > 0 && !reg.test(str); 
    },
    // ===============================
    async asyncGetPatientInfoList(p) {
      let result = await this.$store.dispatch('requestHandler',{
        fn: 'RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList',
        params: {
          userId: p.userId,
          followupTaskId: p.followupTaskId,
          admitNo: p.admitNo,
          patientName: p.patientName,
          followupStatus: p.followupStatus,
          pageIndex: p.pageIndex,
          pageSize: p.pageSize,
        }
      })
      return result
    },
    async asyncGetStatis(params = {}) {
      let data = new RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo();
      data.p_userId = params.userId;
      data.p_followupTaskId = params.followupTaskId;
      data.p_isFrontPage = params.isFrontPage
      await data.send();
      return data.result;
    },
    async getFollowUpTodayCompleteCountAsync(params = {}) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTodayCompleteCount();
      request.p_followUpTaskId = params.followupTaskId;
      request.p_seatId = params.userId;
      await request.send();
      return request.result;
    },
    async getFollowUpTaskSpotCheckStatisticsAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpTaskSpotCheckStatistics();
      request.p_followupTaskId = p.followupTaskId;
      request.p_userId = p.userId;
      await request.send();
      return request.result;
    }
  }
};
</script>
<style lang="scss">
.next-overlay-wrapper .next-overlay-inner {
  z-index: 2001 !important;
}
.taskpage-content {
  .tabs-collect .el-tabs__item{
    padding: 0 13px ;
  }
}

</style>
<style scoped lang="scss">

@media screen and (max-width: 1730px) {
  .task-des-hidden {
    display: none;
  }
  .task-des-tooltip {
    display: inline-block !important;
  }
}
.tabs-container {
  position: relative;
  .refresh-all {
    position: absolute;
    color: #248cfa;
    cursor: pointer;
    right: 0;
    top: 14px;
    font-size: 12px;
  }
}
.container-main {
  min-height: calc(100vh - 60px - 60px);
  margin: 0px;
  padding: 0px;
  .taskpage-processing {
    // display: flex;
    // justify-content: space-between;

    display: grid;
    grid-template-columns: 30% 70%;
    align-items: center;
    height: 60px;
    border-bottom: 1px solid #ccc;
    &-back {
      // min-width: 520px;
      display: flex;
      align-items: center;
      font-size: 18px;
      .task-title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      i {
        font-size: 24px;
        font-weight: bold;
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        width: 50px;
        text-align: center;
      }
      i:hover {
        background: #e4e4e4;
      }
    }
    &-button {
      font-weight: normal;
      font-size: 14px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      width: 380px;
      flex-shrink: 0;
      span {
        border: 1px solid;
        border-radius: 5px;
        margin: 0 10px;
        padding: 10px;
      }
      .hasData {
        border: 1px solid #248cfa;
        color: #248cfa;
      }
      .hasData:hover {
        background: #E9F6FF;
        cursor: pointer;
      }
    }
    .taskpage-processing-button {
      width: 300px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 12px;
      }

    }
    .task-des-container {
      padding-left: 230px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .task-des-item {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 10px 0;
        padding-top: 14px;
        margin-right: 20px;
        background-color: #E9F6FF;
        border-radius: 5px;
        height: 40px;
        font-size: 14px;
        .task-des {
          margin: 0 13px;
        }
        .task-des-followup {
          cursor: pointer;
          color: #248CFA ;
          border-bottom: 1px solid #248CFA ;
        }
        .task-des-tooltip {
          display: none;
        }
        &:nth-last-of-type(1) {
          margin-bottom: 0px;
        }
      }
    }
  }
  .taskpage-content {
    padding: 0 20px;
    display: grid;
    grid-template-columns: 43% auto;
    height: calc(100vh - 60px - 60px - 60px);
    &-item {
      padding: 30px 20px;
    }
    &-title {
      height: 30px;
      line-height: 30px;
      border-left: 5px solid #248cfa;
      display: flex;
      justify-content: space-between;
      .title {
        font-size: 16px;
        font-weight: bold;
        padding: 0 10px;
      }
    }
    
    .refresh-all-right {
      color: #248cfa;
      cursor: pointer;
      font-size: 12px;
      // margin-right: 10px;
    }
    .tabs-collect {
      position: relative;
      .collect-setting {
        position: absolute;
        top: 5px;
        right: 0;
        padding: 5px;
        i {
          font-size: 20px;
        }
      }
      .collect-setting>i:hover {
        background: #ebebeb;
      }
    }
  }
}

// 修改Tab样式
.new-tabs-header {
  .el-tabs__nav-wrap {
    &::after {
      display: none;
    }
  }
}
// 收藏夹
.taskpage-container {
  .collect-dialog {
    .table-container {
      min-height: 350px;
    }
    .collect-dialog-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  }
}
</style>
<style>
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #fff !important;
}
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #ccc !important;
}
.el-tooltip__popper{
  border-color:#ccc !important;
}
</style>

